'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARET_CLASS_FOR_USE = {
  form: 'private-dropdown__caret--form',
  'form-on-dark': 'private-dropdown__caret--form',
  'link-on-dark': 'private-dropdown__caret--link-on-dark'
};

var UIDropdownCaret = function UIDropdownCaret(_ref) {
  var className = _ref.className,
      hidden = _ref.hidden,
      use = _ref.use;

  var computedClassName = (0, _classNames2.default)(className, 'uiDropdown__buttonCaret', 'private-dropdown__caret', CARET_CLASS_FOR_USE[use], {
    'private-dropdown__caret--hidden': hidden
  });
  return _react2.default.createElement('span', { className: computedClassName });
};

UIDropdownCaret.propTypes = {
  hidden: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES))
};

UIDropdownCaret.displayName = 'UIDropdownCaret';

exports.default = UIDropdownCaret;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dropdown/UIDropdownCaret.js
// module id = 528
// module chunks = 3 4 5